import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { Organization } from './organization';
export { Organization };
import { organizationSchema } from '@schemas/business-objects/organization';
import { OrganizationPropertyValueFormArray } from './organization-property-value-form-group';
import { StudentFormArray } from './student-form-group';
import { TermFormArray } from './term-form-group';

export class OrganizationFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    name: SchemaFormControl;
    type: SchemaFormControl;
    website: SchemaFormControl;
    fromGrade: SchemaFormControl;
    toGrade: SchemaFormControl;
    phone: SchemaFormControl;
    streetAddress: SchemaFormControl;
    city: SchemaFormControl;
    state: SchemaFormControl;
    zip: SchemaFormControl;
    county: SchemaFormControl;
    organizationPropertyValues: OrganizationPropertyValueFormArray;
    students: StudentFormArray;
    terms: TermFormArray;
  };

  declare value: Partial<Organization>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(organizationSchema, Organization, data, options);
  }

  get object(): Organization {
    return new Organization(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'organizationPropertyValues':
        return new OrganizationPropertyValueFormArray();
      case 'students':
        return new StudentFormArray();
      case 'terms':
        return new TermFormArray();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<Organization[]> {
    return Organization.find(filter);
  }

  static async findOne(filter?: any): Promise<Organization | null> {
    return Organization.findOne(filter);
  }

  static async findById(id: number, filter?: any): Promise<Organization> {
    return Organization.findById(id, filter);
  }

  static async create(data: Partial<Organization>): Promise<Organization> {
    return Organization.create(data as any);
  }

  static async updateById(
    id: number,
    updates: Partial<Organization>,
  ): Promise<Organization> {
    return Organization.updateById(id, updates as any);
  }

  static async deleteById(id: number): Promise<boolean> {
    return Organization.deleteById(id);
  }
}

export class OrganizationFormArray extends PersistedFormArray {
  readonly entityName = 'Organization' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(organizationSchema, Organization, options);
  }

  protected override createItemGroup() {
    return new OrganizationFormGroup();
  }

  get array(): Organization[] {
    return this.controls.map((group: OrganizationFormGroup) => group.object);
  }
}

export class OrganizationPersistedArray extends PersistedArray<Organization> {
  readonly entityName = 'Organization' as const;

  constructor(options?: PersistedArrayOptions) {
    super(Organization, options);
  }
}
